import { Component, Input, TemplateRef } from '@angular/core';
import { BaseComponent } from "../base/base.component";
import { Router } from "@angular/router";
import { RestClient } from '../rest-client.service';
import { AuthService } from '../base/auth/auth.service';
import { NotificationsService } from './notifications.service';
import { I18NService } from '../base/utils/i18n.service';
/**
 * App-Component
 */
@Component({
    selector: '<skitbs-user-confirmation>',
    templateUrl: './userConfirmation.component.html'
})
export class UserConfirmationComponent extends BaseComponent {

    confirmationText : string;
    confirmationId : number;

    /**
     * Constructor.
     * @param restClient
     */
    constructor(private router: Router, private restClient: RestClient, private notificationsService: NotificationsService, private auth: AuthService) {
        super();
    }

    /**
     * Lifecycle.
     */
    ngOnInit(): void {
        const cpNo = this.auth.findCurrentSession().cpNr;
        const confirmations = this.notificationsService.notifications[cpNo];
        if (!confirmations) this.router.navigate(['/orders']);
        else {
            this.confirmationText = this.i18n.extractTextWithFallBack(confirmations[0].i18nTexts);
            this.confirmationId = this.notificationsService.notifications[cpNo][0].entity.id;
        }
    }

    acceptChanges() {
        this.restClient.setUserConfirmation(this.confirmationId, true).subscribe(respone =>this.router.navigate(['/orders']));
;
    }

    rejectChanges() {
        this.restClient.setUserConfirmation(this.confirmationId, false).subscribe(respone =>this.router.navigate(['/orders']));
    }

    decideLater() {
        this.router.navigate(['/orders']);
    }
}
